var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQrCodeAim = function SvgQrCodeAim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235,
    height: 235,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M65 .535A3.981 3.981 0 0 0 63 0H8a8 8 0 0 0-8 8v57c0 .345.044.68.126 1H8V12a4 4 0 0 1 4-4h53V.535ZM65 228H12a4 4 0 0 1-4-4v-54H.126c-.082.32-.126.655-.126 1v56a8 8 0 0 0 8 8h55c.729 0 1.412-.195 2-.535V228Zm102 6.465c.588.34 1.271.535 2 .535h58a8 8 0 0 0 8-8v-56c0-.345-.044-.68-.126-1H228v54a4 4 0 0 1-4 4h-57v6.465ZM167 8h57a4 4 0 0 1 4 4v54h6.874a4.02 4.02 0 0 0 .126-1V8a8 8 0 0 0-8-8h-58a3.98 3.98 0 0 0-2 .535V8Z",
    clipRule: "evenodd"
  })));
};
export default SvgQrCodeAim;